<template>
  <ul class="types">
    <li>
      <button
        class="types__button"
        :class="{ 'types__button--active': isShopAllSelected }"
        @click="handleShopAllClick"
      >
        Shop all
      </button>
    </li>
    <li v-if="hasCampaignSaleProducts">
      <button
        class="types__button types__button--campaign-sale"
        :class="{ 'types__button--active': isCampaignSaleSelected }"
        @click="handleCampaignSaleClick"
      >
        12 Days of Discounts
      </button>
    </li>
    <template v-if="isJewelleryCollection">
      <li v-for="group in jewelleryGroups" :key="group.id">
        <button
          class="types__button"
          :class="{ 'types__button--active': titleGroup === group.id }"
          @click="handleJewelleryGroupClick(group.id)"
        >
          {{ group.label }}
        </button>
      </li>
    </template>
    <template v-else>
      <li v-for="productType in types" :key="productType.id">
        <button
          class="types__button"
          :class="{ 'types__button--active': isFilterSelected(productType) }"
          @click="handleTypeClick(productType.input)"
        >
          {{ productType.label }}
        </button>
      </li>
    </template>
  </ul>
</template>

<script>
import isEqual from "lodash-es/isEqual";
import { mapGetters, mapState } from "vuex";
import {
  JEWELLERY_COLLECTION_HANDLE,
  JEWELLERY_GROUPS,
} from "@/helpers/jewelleryGroups";

export default {
  name: "ProductTypes",
  emits: ["change"],
  computed: {
    ...mapState("collection", ["filters", "titleGroup", "collection"]),
    ...mapGetters("collection", ["types", "availableFilters"]),
    jewelleryGroups() {
      return JEWELLERY_GROUPS;
    },
    isJewelleryCollection() {
      return this.collection?.handle === JEWELLERY_COLLECTION_HANDLE;
    },
    isShopAllSelected() {
      const noShopifyType = !this.filters.some(
        ({ productType, productMetafield }) => productType || productMetafield
      );

      if (this.isJewelleryCollection) {
        return noShopifyType && !this.titleGroup;
      }

      return noShopifyType;
    },
    isCampaignSaleSelected() {
      return this.filters.some(
        ({ productMetafield }) => productMetafield?.value === "true"
      );
    },
    hasCampaignSaleProducts() {
      return this.availableFilters.some(
        (filter) => filter.id === "filter.p.m.ratandboa.on_campaign_sale"
      );
    },
  },
  methods: {
    isFilterSelected(productType) {
      const { input } = productType;
      const valueInput = JSON.parse(input);
      const filterKey = Object.keys(valueInput)[0];

      return this.filters.some((selectedFilter) =>
        isEqual(selectedFilter[filterKey], valueInput[filterKey])
      );
    },
    handleCampaignSaleClick() {
      const campaignSaleFilter = this.availableFilters.find(
        ({ id }) => id === "filter.p.m.ratandboa.on_campaign_sale"
      );

      if (campaignSaleFilter?.values?.length) {
        this.handleTypeClick(campaignSaleFilter.values[0].input);
      }
    },
    handleShopAllClick() {
      if (this.isJewelleryCollection) {
        this.$emit("change", { titleGroup: null });
        return;
      }

      this.handleTypeClick({ productType: null, productMetafield: null });
    },
    handleJewelleryGroupClick(groupId) {
      this.$emit("change", { titleGroup: groupId });
    },
    handleTypeClick(input) {
      let emittedValue = input;

      if (typeof input == "string") {
        emittedValue = JSON.parse(input);

        if (!emittedValue.productMetafield) {
          emittedValue = { ...emittedValue, productMetafield: null };
        }
      }

      this.$emit("change", emittedValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.types {
  overflow-y: auto;
  white-space: nowrap;
  display: flex;
  gap: 12px;
  @extend .container;

  @include respond-above(md) {
    flex-wrap: wrap;
    justify-content: center;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  li {
    flex: 0 0 auto;
    display: inline-block;
  }

  &__button {
    padding: 8px 12px;
    background-color: $color-grey-light;
    color: $color-black;
    border-radius: 4px;
    @include utility-button(13px);
    border: none;
    outline: none;
    text-decoration: none;
    text-align: center;

    &--active {
      background-color: $color-black;
      color: $color-white;
    }

    &--campaign-sale {
      background-color: $color-red;
      color: $color-white;

      &.types__button--active {
        background-color: $color-black;
        color: $color-white;
      }
    }
  }
}
</style>
